var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01991 14.6361C4.33997 13.7528 4 13.3111 4 11.9996C4 10.6881 4.33997 10.2464 5.01991 9.36307C6.37757 7.59926 8.65449 5.59961 12 5.59961C15.3455 5.59961 17.6224 7.59926 18.9801 9.36307C19.66 10.2464 20 10.6881 20 11.9996C20 13.3111 19.66 13.7528 18.9801 14.6361C17.6224 16.4 15.3455 18.3996 12 18.3996C8.65449 18.3996 6.37757 16.4 5.01991 14.6361Z",
    stroke: "#234635",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3996 11.9996C14.3996 13.3251 13.3251 14.3996 11.9996 14.3996C10.6741 14.3996 9.59961 13.3251 9.59961 11.9996C9.59961 10.6741 10.6741 9.59961 11.9996 9.59961C13.3251 9.59961 14.3996 10.6741 14.3996 11.9996Z",
    stroke: "#234635",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/EyeOpen.f4b90e36261da3ea255b71bf14238d2c.svg";
export { ForwardRef as ReactComponent };